const state = {
  pdfs: [],
  videoVisible: false,
  vid: null,
  // 用于pdf中img，判断是否在当前页面
  page:null,
};

const mutations = {
  SET_VIDEO_VISIABLE: (state, { visible }) => {
    state.videoVisible = visible;
  },
  SET_VIDEO_ID: (state,  vid ) => {
    state.vid = vid;
  },
  SET_PAGE: (state,  page ) => {
    state.page = page;
  }
};

const actions = {
  SET_VIDEO_VISIABLE({ commit }, value) {
    commit("SET_VIDEO_VISIABLE", { value });
  },
  SET_VIDEO_ID({ commit }, value) {
    commit("SET_VIDEO_ID",  value );
  },
  SET_PAGE({ commit }, value) {
    commit("SET_PAGE",  value );
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
